import { Checkbox, Form } from 'antd';

type SchemaFormCheckboxProps = {
  name: (string | number)[] | string;
  label?: string;
  disabled?: boolean;
};

export const SchemaFormCheckbox: React.FC<SchemaFormCheckboxProps> = ({ name, disabled, label }) => {
  const f = Form.useFormInstance();
  const val = Form.useWatch(name, f);
  return (
    <Checkbox
      checked={!!val}
      disabled={disabled}
      onChange={disabled ? undefined : e => f.setFieldValue(name, e.target.checked)}
    >
      {label}
    </Checkbox>
  );
};
